module.exports = __webpack_public_path__ + "static/media/gw.47fd8d67.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gw.svg
// module id = 842
// module chunks = 0